module.exports = __webpack_public_path__ + "static/media/p508v.962cd440.jpg";